import React, { useState } from 'react';
import BackButton from "../widgets/BackButton";
import moment from "moment";
import { observer } from 'mobx-react';



let ListMessages = ({ ...props }) => {
    props.store.updateBanner(`See messages`);

    if (props.store.messages.collection.length == 0) {
        props.store.getFromApi(["messages"]);
    }

    console.log(props.store)


    const listMessages = () =>  {
        const messages = [... props.store.messages.collection] //Shallow copy
        messages.reverse() //Most recent first.

        if (messages.length > 0) {
            return (
                <div>
                    {messages.map(message => (
                        <div key={"message" + message.id}>
                            <div className="row">
                                <div className="comfirmEmailDisplay col-12 col-md-8" dangerouslySetInnerHTML={{ __html: message.emailBody } }></div>
                                <div className="col-12 col-md-4">
                                    <p><b>To</b>: {props.store.user.studentName}</p>
                                    <p><b>Date</b>: {moment(message.createdDate).format("LL")}</p>
                
                                    <p className="mt-3"><b>From</b>: {message.senderName}</p>
                
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )
        }
        else {
            return (
                <div>
                    <h3>No Messages Found</h3>
                    <p>You have not recieved any messages.</p>
                </div>
            )
        }
    } 

    
    return (
        <div>
            <h1 className="h2">Messaging</h1>
            <p>This page lists all of the messages sent to you by an admin.</p>
            {listMessages()}
        </div>
    )
}


export default ListMessages;